import { useDateFilters } from "./useDateFilters";
import { useDebouncedTableFilter } from "./useDebouncedTableFilter";

export const useQualityResultsFilters = () => {
  const {
    debouncedValue: debouncedNameValue,
    handleFilterChange: handleNameValue,
    value: nameValue,
    clearFilterValue: clearNameValue,
  } = useDebouncedTableFilter("Name", 400);

  const {
    debouncedValue: debouncedBatchCodeValue,
    handleFilterChange: handleBatchCodeValue,
    value: batchCodeValue,
    clearFilterValue: clearBatchCodeValue,
  } = useDebouncedTableFilter("BatchCode", 400);

  const {
    debouncedValue: debouncedSerialNumberValue,
    handleFilterChange: handleSerialNumberValue,
    value: serialNumberValue,
    clearFilterValue: clearSerialNumberValue,
  } = useDebouncedTableFilter("SerialNumber", 400);

  const {
    debouncedValue: debouncedSupplierValue,
    handleFilterChange: handleSupplierValue,
    value: supplierValue,
    clearFilterValue: clearSupplierValue,
  } = useDebouncedTableFilter("SupplierValue", 400);

  const {
    debouncedValue: debouncedMaterialGradeValue,
    handleFilterChange: handleMaterialGradeValue,
    value: materialGradeValue,
    clearFilterValue: clearMaterialGradeValue,
  } = useDebouncedTableFilter("MaterialGradeValue", 400);

  const {
    debouncedValue: debouncedMaterialTypeValue,
    handleFilterChange: handleMaterialTypeValue,
    value: materialTypeValue,
    clearFilterValue: clearMaterialTypeValue,
  } = useDebouncedTableFilter("MaterialTypeValue", 400);

  const {
    debouncedValue: debouncedTypeValue,
    handleFilterChange: handleTypeValue,
    value: typeValue,
    clearFilterValue: clearTypeValue,
  } = useDebouncedTableFilter("ResultTypeValue", 400);

  const {
    dateGreater,
    dateLesser,
    handleDateGreater,
    handleDateLesser,
    clearDates,
    isDataFilterActive,
  } = useDateFilters();

  const isActiveFiltering =
    nameValue.length ||
    batchCodeValue.length ||
    serialNumberValue.length ||
    supplierValue.length ||
    isDataFilterActive ||
    materialTypeValue.length ||
    typeValue.length;

  const clearAllFilters = () => {
    clearNameValue();
    clearBatchCodeValue();
    clearSerialNumberValue();
    clearSupplierValue();
    clearDates();
    clearMaterialTypeValue();
    clearTypeValue();
  };

  return {
    nameValue,
    debouncedNameValue,
    handleNameValue,
    clearNameValue,
    serialNumberValue,
    debouncedSerialNumberValue,
    handleSerialNumberValue,
    clearSerialNumberValue,
    supplierValue,
    debouncedSupplierValue,
    handleSupplierValue,
    clearSupplierValue,
    dateGreater,
    handleDateGreater,
    dateLesser,
    handleDateLesser,
    clearDates,
    isActiveFiltering,
    clearAllFilters,
    isDataFilterActive,
    debouncedBatchCodeValue,
    clearBatchCodeValue,
    handleBatchCodeValue,
    batchCodeValue,
    debouncedMaterialGradeValue,
    handleMaterialGradeValue,
    materialGradeValue,
    clearMaterialGradeValue,
    materialTypeValue,
    handleMaterialTypeValue,
    debouncedMaterialTypeValue,
    debouncedTypeValue,
    typeValue,
    handleTypeValue,
    clearTypeValue,
  };
};
